
  export default {
    timeoutId: null,

    mounted() {
      this.handleClick = this.handleClick.bind(this)
      this.el.addEventListener("click", this.handleClick)
    },

    destroyed() {
      this.el.removeEventListener("click", this.handleClick)
      if (this.timeoutId) {
        clearTimeout(this.timeoutId)
      }
    },

    handleClick(e) {
      e.preventDefault()

      // Check if button is disabled
      if (this.el.disabled || this.el.classList.contains("cursor-not-allowed")) {
        return
      }

      const url = this.el.dataset.downloadUrl
      const filename = this.el.dataset.downloadName
      const loadingEvent = this.el.dataset.loadingEvent
      const successEvent = this.el.dataset.successEvent
      const errorEvent = this.el.dataset.errorEvent
      const pushTarget = this.el.dataset.pushTarget
      const recordEvent = this.el.dataset.recordEvent
      const longerEvent = this.el.dataset.longerEvent
      const longerTimeout = parseInt(this.el.dataset.longerTimeout) || 20000

      if (!url || url === "#") {
        console.error("DownloadButton: No valid download-url specified")
        return
      }

      // Emit loading event if specified
      if (loadingEvent) {
        this.pushEventToTarget(pushTarget, loadingEvent)
      }

      // Set timeout for longer event if specified
      if (longerEvent) {
        this.timeoutId = setTimeout(() => {
          this.pushEventToTarget(pushTarget, longerEvent)
        }, longerTimeout)
      }

      // Fetch the file
      fetch(url)
        .then((response) => {
          if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`)
          }
          return response.blob()
        })
        .then((blob) => {
          // Create blob URL and trigger download
          const blobUrl = window.URL.createObjectURL(blob)
          const anchor = document.createElement("a")
          anchor.style.display = "none"
          anchor.href = blobUrl
          anchor.download = filename
          document.body.appendChild(anchor)
          anchor.click()

          // Cleanup
          window.URL.revokeObjectURL(blobUrl)
          document.body.removeChild(anchor)

          // Clear timeout since download succeeded
          if (this.timeoutId) {
            clearTimeout(this.timeoutId)
          }

          // Emit success event if specified
          if (successEvent) {
            this.pushEventToTarget(pushTarget, successEvent)
          }

          // Emit record event if specified (for analytics)
          if (recordEvent) {
            this.pushEvent(recordEvent)
          }
        })
        .catch((error) => {
          console.error("Download failed:", error)

          // Clear timeout on error
          if (this.timeoutId) {
            clearTimeout(this.timeoutId)
          }

          // Emit error event if specified
          if (errorEvent) {
            this.pushEventToTarget(pushTarget, errorEvent, {
              error: error.message,
            })
          }
        })
    },

    pushEventToTarget(target, event, payload = {}) {
      if (target) {
        this.pushEventTo(target, event, payload)
      } else {
        this.pushEvent(event, payload)
      }
    }
  }
